module.exports = __webpack_public_path__ + "static/media/join.eb3e25aa.svg";